import { Link } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';

interface SidebarLinkProps {
  to: string;
  icon: LucideIcon;
  label: string;
  isActive: boolean;
  isCollapsed?: boolean;
  className?: string;
}

export default function SidebarLink({ to, icon: Icon, label, isActive, isCollapsed, className = '' }: SidebarLinkProps) {
  return (
    <Link
      to={to}
      className={`flex items-center space-x-3 rounded-lg px-3 py-2.5 transition-all duration-200 ${className} ${
        isActive
          ? 'bg-accent-400/10 text-accent-500 border-l-2 border-accent-400 dark:bg-accent-400/10 dark:text-accent-400'
          : 'text-navy-600 hover:bg-navy-100 hover:text-accent-500 dark:text-navy-300 dark:hover:bg-navy-800 dark:hover:text-accent-400'
      }`}
    >
      <Icon className={`h-5 w-5 ${isActive ? 'text-accent-500 dark:text-accent-400' : ''}`} />
      {!isCollapsed && <span className="font-medium">{label}</span>}
    </Link>
  );
}
